export default {
    ratingInputTouchEnabled: false,
    npsInputTouchEnabled: true,
};
